import { userInfo } from "./global";

export function authority(auth) {
  if(!auth) return true
  const role = userInfo?.value?.administrator == 1 ? 'admin' : 'salesman'
  return auth?.split(',').includes(role)
}